<script>
import { cloneDeep } from 'lodash-es';
import ItineraryPricesGroupPaxRow from './ItineraryPricesGroupPaxRow';

export default {
  name: 'ItineraryPricesGroupPax',
  components: {
    ItineraryPricesGroupPaxRow,
  },
  props: {
    groupPaxes: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    buttonColor: {
      type: String,
      default: 'primary',
    },
    rowName: {
      type: String,
      default: 'Pax row',
    },
    mask: {
      type: String,
      default: '##-##',
    },
    discounts: {
      type: Boolean,
      default: false,
    },
    singleDigit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupPaxDialog: false,
      defaultGroupPax: {
        text: null,
        value: null,
        key: null,
      },
      discountKey: 1,
      groupKey: 10,
      localGroupPaxs: [],
      validationMessage: 'Please separate paxes with a dash ( - ) (10-15)',
      showValidationMessage: false,
    };
  },
  created() {
    this.init(this.groupPaxes);
  },
  watch: {
    groupPaxes: {
      deep: true,
      handler(value) {
        this.init(value);
        if (this.discounts && value.length) {
          this.discountKey = Math.max(...value.map(e => e.discountKey)) + 1;
        }
      },
    },
  },
  methods: {
    init(groupPaxes) {
      if (!groupPaxes.length) {
        this.addGroupPaxRow();
      } else {
        this.localGroupPaxs = [...groupPaxes];
      }
    },
    setGroupPax() {
      const validated = this.localGroupPaxs.every(e => e.text.includes('-'));

      if (validated) {
        this.$emit('save', this.localGroupPaxs);
        this.groupPaxDialog = false;
        this.showValidationMessage = false;
      } else {
        this.showValidationMessage = true;
      }
    },
    updateGroupPax(item) {
      const groupPaxes = [...this.localGroupPaxs];
      groupPaxes[item.index] = item.value;
      this.localGroupPaxs = groupPaxes;
    },
    addGroupPaxRow(index) {
      const groupPaxes = [...this.localGroupPaxs];
      const defaultPax = cloneDeep(this.defaultGroupPax);

      if (this.localGroupPaxs.length) {
        const previousPax = this.localGroupPaxs[index];

        if (previousPax) {
          const newStartRange = previousPax.text.split('-')[1];
          defaultPax.text = (+newStartRange + 1).toString();
        }
      }

      if (this.discounts) {
        defaultPax.discountKey = this.discountKey;
        this.discountKey++;
      } else {
        defaultPax.priceKey = this.groupKey;
        this.groupKey++;
      }

      groupPaxes.push(defaultPax);
      this.localGroupPaxs = groupPaxes;
    },
    removeGroupPax(index) {
      const groupPaxes = [...this.localGroupPaxs];
      groupPaxes.splice(index, 1);
      this.localGroupPaxs = cloneDeep(groupPaxes);
    },
    validationFailed(value) {
      this.showValidationMessage = !!value;
    },
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="groupPaxDialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :color="buttonColor"
          dark
          v-on="on"
        >
          {{ title }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ title }}
        </v-card-title>

        <v-subheader class="pa-2" v-if="showValidationMessage">
          {{ validationMessage }}
        </v-subheader>

        <itinerary-prices-group-pax-row
          v-for="(groupPax, index) in localGroupPaxs"
          :key="`itinerary-prices-group-pax-row-${index}`"
          :group-pax="groupPax"
          :index="index"
          :row-name="rowName"
          :mask="mask"
          :single-digit="singleDigit"
          @add="addGroupPaxRow"
          @input="updateGroupPax"
          @remove="removeGroupPax"
          @validation="validationFailed"
        />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click="setGroupPax"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesGroupPax.vue